import { honeybadger } from "shared/api/honeybadger/honeybadger.config"
import { request } from "shared/api/request"
import { FEEDBACK_OVERLAY } from "shared/context/overlay/types"
import { useAuth } from "shared/lib/useAuth"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"
import { FeedbackType } from "shared/types/FeedbackType"

import { createFeedbackMessage } from "features/feedback/lib/createFeedbackMessage"

export interface FeedbackAttachment {
  s3Key: string
  fileName: string
}

export interface SendFeedbackPayload {
  feedbackType: FeedbackType
  link?: string
  message: string
  attachments?: FeedbackAttachment[]
}

export function useFeedback() {
  const { userInfo } = useAuth()
  const { openOverlay: openFeedbackOverlay } = useOverlay(FEEDBACK_OVERLAY)

  const handleSendFeedback = useEvent((payload: SendFeedbackPayload) => {
    const promise = request(
      `${import.meta.env.VITE_API_BASE}/feedback/create`,
      {
        method: "POST",
        body: JSON.stringify(
          createFeedbackMessage({
            ...payload,
            userInfo
          })
        ),
        headers: {
          "content-type": "application/json"
        }
      }
    )

    handleFeedbackError(promise, payload)

    return promise
  })

  return {
    openFeedbackOverlay,
    sendFeedback: handleSendFeedback
  }
}

function handleFeedbackError(
  promise: Promise<Response | null>,
  payload: SendFeedbackPayload
) {
  promise
    .then(res => {
      if (!res?.ok) {
        honeybadger.notify(new Error("FeedbackError"), "FeedbackError", {
          url: window.location.href,
          params: payload as unknown as Record<string, string>,
          tags: ["Feedback"],
          name: "FeedbackError"
        })
      }
    })
    .catch(e => {
      honeybadger.notify(e, "FeedbackError", {
        url: window.location.href,
        params: payload as unknown as Record<string, string>,
        tags: ["Feedback"],
        name: "FeedbackError"
      })
    })
}
